<mat-expansion-panel [expanded]="initialExpanded" (opened)="toggleExpanded()" (closed)="toggleExpanded()">
    <mat-expansion-panel-header>
        <mat-panel-title>FORMS</mat-panel-title>
        <mat-panel-description class="forms-header-actions">
            <button mat-icon-button type="button" *ngIf="!stateMode" (click)="openSendDialog($event)"
                matTooltip="Send a form to this patient">
                <mat-icon>send</mat-icon>
            </button>
        </mat-panel-description>
    </mat-expansion-panel-header>

    <div class="forms-info">
        <ng-container *ngIf="requests; else listLoading">
            <ng-container *ngIf="requests.length; else noResults">
                <mat-list class="full-width">
                    <ng-container *ngFor="let request of requests; trackBy: trackByRequest">
                        <mat-list-item class="auto-height">
                            <div class="form-item stack-mobile">
                                <div class="details" [class.openable]="canOpen(request)"
                                    (click)="toggleRow(request)">

                                    <div matLine class="form-title">
                                        <span>{{ formName(request) }}</span>
                                        <!--
                                            Five statuses, five looks. `Started` is called out
                                            separately because it means the patient opened the link
                                            and their draft is saved - a reminder will probably
                                            work, which is not true of an untouched `pending`.
                                        -->
                                        <span class="form-status" [ngClass]="statusClass(request)">
                                            {{ statusLabel(request) }}
                                        </span>
                                        <span class="form-score" *ngIf="hasScore(request)"
                                            matTooltip="Score for this completed form">
                                            {{ scoreLabel(request) }}
                                        </span>
                                    </div>

                                    <div matLine class="form-dates">
                                        <span *ngIf="sentAt(request)">
                                            Sent {{ sentAt(request) | date: 'longDate' }}
                                        </span>
                                        <span *ngIf="request.completedAt">
                                            Completed {{ request.completedAt | date: 'longDate' }}
                                        </span>
                                        <span *ngIf="isStatus(request, 'in_progress')">
                                            Started {{ request.startedAt | date: 'longDate' }}
                                        </span>
                                        <span *ngIf="request.resendCount">
                                            Resent {{ request.resendCount }}&times;
                                        </span>
                                    </div>

                                    <div matLine class="form-open-hint" *ngIf="canOpen(request)">
                                        <mat-icon>{{ isOpen(request) ? 'expand_less' : 'expand_more' }}</mat-icon>
                                        <span>{{ isOpen(request) ? 'Hide answers' : 'View answers' }}</span>
                                    </div>
                                </div>

                                <div class="action-icons">
                                    <!--
                                        Resend rotates the token (patient-forms.md 14.3 decision 2):
                                        the link already sent stops working. The confirmation says
                                        so. Disabled while the invite cooldown runs, exactly as the
                                        consent panel disables its own resend on
                                        `nextAllowedResendAt`.
                                    -->
                                    <button mat-icon-button type="button" *ngIf="canResend(request)"
                                        [disabled]="!resendAllowed(request) || busyRequestId === request.id"
                                        [matTooltip]="resendTooltip(request)"
                                        (click)="resend(request, $event)">
                                        <mat-icon>send</mat-icon>
                                    </button>

                                    <button mat-icon-button type="button" *ngIf="canRevoke(request)"
                                        [disabled]="busyRequestId === request.id"
                                        matTooltip="Cancel this form request"
                                        (click)="revoke(request, $event)">
                                        <mat-icon>block</mat-icon>
                                    </button>
                                </div>
                            </div>
                        </mat-list-item>

                        <!--
                            THE ANSWERS. Rendered by the ONE shared renderer in readonly mode with
                            the schema of the version the patient was actually given - never a
                            hand-rolled answer table (patient-forms.md 5).
                        -->
                        <div class="form-answers" *ngIf="isOpen(request)">
                            <div class="form-answers-loading" *ngIf="detailLoading[request.id]">
                                <mat-spinner color="primary" mode="indeterminate" diameter="20"></mat-spinner>
                            </div>

                            <p class="form-answers-error" *ngIf="detailError[request.id]">
                                {{ detailError[request.id] }}
                            </p>

                            <ng-container *ngIf="details[request.id]">
                                <div class="form-answers-version" *ngIf="versionLabel(request)">
                                    {{ versionLabel(request) }}
                                </div>

                                <app-dynamic-form-renderer [schema]="schemaFor(request)"
                                    [value]="answersFor(request)" [readonly]="true">
                                </app-dynamic-form-renderer>
                            </ng-container>
                        </div>
                    </ng-container>
                </mat-list>
            </ng-container>
        </ng-container>
    </div>
</mat-expansion-panel>

<ng-template #listLoading>
    <div class="list-loading">
        <mat-spinner color="primary" mode="indeterminate" diameter="20" style="float:right;"></mat-spinner>
    </div>
</ng-template>

<ng-template #noResults>
    <p class="no-records-message">No forms have been sent to this patient yet.</p>
</ng-template>
